<app-badge customToolTip [contentTemplate]="metrics">
  <mat-icon class="material-icons-outlined">analytics</mat-icon>
  <span>{{ datasource.datasetUsageCustomConfiguration$.value.nbMetrics$ | async }} {{ 'data_sources.metrics' | translate | lowercase }}</span>
  <mat-icon class="material-icons-outlined icon-hover">info</mat-icon>
</app-badge>
<ng-template #metrics>
  <app-source [item]="metric.item$.value.payload" *ngFor="let metric of datasource.datasetUsageCustomConfiguration$.value.metrics$ | async"></app-source>
</ng-template>
